/* eslint-disable max-len */
import {SVGProps} from 'react';

const LikeFillSvg = (props: SVGProps<SVGSVGElement>) => (
    <svg width="38px" height="38px" viewBox="0 0 38 38" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <defs>
            <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="LikeFillSvg_linearGradient-1">
                <stop stopColor="#59ADFF" offset="0%"></stop>
                <stop stopColor="#3377FF" offset="100%"></stop>
            </linearGradient>
            <path
                d="M11.6464607,1.56867569 C13.0145324,-0.0594393385 15.3111026,-0.475911897 17.1400882,0.582263515 C18.9561739,1.63286925 19.6834581,3.92954861 18.8534783,5.82867252 L18.8534783,5.82867252 L18.1421885,7.63628595 L22.7523711,7.63741814 C23.6089396,7.6371847 24.4235328,7.98299897 25.0260837,8.58808336 L25.0260837,8.58808336 L25.2417686,8.82697381 C25.8462763,9.56596417 26.1068785,10.5358907 25.9598394,11.4851222 L25.9598394,11.4851222 L24.2779575,22.3388882 C23.9528834,24.4385775 22.1925743,26 20.1061619,26 L20.1061619,26 L1.10151724,26 C0.493166067,26 7.45015318e-17,25.5068339 0,24.8984828 L0,24.8984828 L0,10.9635497 C0,9.13832383 1.44130705,7.63741809 3.24675463,7.63741809 L3.24675463,7.63741809 L4.732,7.637 L4.73233015,7.63685679 L6.52775003,7.63741809 L6.52775003,7.63741809 L4.732,7.637 L4.82641734,16.6132506 L4.84299549,16.7791941 C4.94637851,17.320353 5.51913399,17.7320789 6.20567487,17.7272303 C6.96086984,17.7218064 7.56776817,17.2143559 7.56122024,16.5937648 L7.56122024,16.5937648 L7.4602391,7.02311306 L7.44933015,6.92085679 L7.08001325,7.38711088 L7.01166638,7.46174276 C6.89115849,7.57577618 6.73952458,7.6374261 6.58460749,7.63741809 L6.58460749,7.63741809 L6.52775003,7.63741809 C6.71368448,7.6374277 6.89489029,7.54864989 7.02324624,7.38711088 L7.02324624,7.38711088 Z"
                id="LikeFillSvg_path-2"
            >
            </path>
            <filter x="-42.3%" y="-26.9%" width="184.6%" height="184.6%" filterUnits="objectBoundingBox" id="LikeFillSvg_filter-3">
                <feOffset dx="0" dy="4" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix
                    values="0 0 0 0 0   0 0 0 0 0.201257862   0 0 0 0 1  0 0 0 0.2 0"
                    type="matrix"
                    in="shadowBlurOuter1"
                >
                </feColorMatrix>
            </filter>
        </defs>
        <g id="LikeFillSvg_知识币机制" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="LikeFillSvg_hover卡片备份" transform="translate(-563.000000, -585.000000)">
                <g id="LikeFillSvg_编组-9备份-3" transform="translate(464.000000, 569.000000)">
                    <g id="LikeFillSvg_编组-7" transform="translate(85.000000, 0.000000)">
                        <g id="LikeFillSvg_形状结合" transform="translate(20.000000, 18.000000)">
                            <use fill="url(#LikeFillSvg_linearGradient-1)" fillRule="evenodd" xlinkHref="#LikeFillSvg_path-2"></use>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default LikeFillSvg;
